export default __webpack_public_path__ + "static/media/new-confirmed-icon.6c2c5913.svg";